export enum PaymentHealth {
  CURRENT = 'current',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
}
